import { render, staticRenderFns } from "./privacy-page.vue?vue&type=template&id=0d09585f&scoped=true&lang=pug&"
import script from "./privacy-page.vue?vue&type=script&lang=js&"
export * from "./privacy-page.vue?vue&type=script&lang=js&"
import style0 from "./privacy-page.vue?vue&type=style&index=0&id=0d09585f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d09585f",
  null
  
)

export default component.exports